module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-box"
  }, [_c('transition-group', {
    attrs: {
      "name": "notification-list",
      "tag": "div"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('notify', {
      key: item.id,
      attrs: {
        "type": item.type,
        "title": item.title,
        "content": item.content,
        "onClose": item.onClose,
        "icon": item.icon,
        "index": index,
        "time": item.time
      },
      on: {
        "close": _vm.closes
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-60d86c97!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/notification/notification.vue
// module id = 478
// module chunks = 27